<template>
  <base-query class="mismatch-aisport">
    <div style="text-align: right; margin: 5px 0">
      <el-button size="small" :loading="isloading" @click="refresh">
        刷新
      </el-button>

      <el-button
        type="danger"
        size="small"
        :disabled="!selections.length"
        :loading="removing"
        @click="removeAll"
      >
        删除
      </el-button>
    </div>

    <el-table
      v-loading="isloading"
      :data="mismatchResults"
      size="mini"
      height="690"
      max-height="690"
      row-key="id"
      :border="false"
      :row-class-name="
        ({ row }) => row.id === dialogObject.hideId && 'dialog-is-open'
      "
      @selection-change="handleSelection"
    >
      <el-table-column type="selection" width="50" />

      <el-table-column prop="id" label="ID" width="60" />

      <el-table-column prop="name" label="港口名" />

      <el-table-column prop="code" label="港口代码" width="150" />

      <el-table-column prop="tz" label="时区" width="80" align="center" />

      <el-table-column prop="countryCode" label="国家代码" width="80" />

      <el-table-column prop="createTime" label="创建时间" width="150" />

      <el-table-column label="原因" width="300">
        <div
          slot-scope="scope"
          :class="handleMismatchReasonClass(scope.row.reason)"
        >
          {{ handleMismatchReasonMsg(scope.row.reason) }}
        </div>
      </el-table-column>

      <el-table-column label="操作" width="100">
        <div slot-scope="scope">
          <el-button type="text" @click="doLookup(scope.row)">查看</el-button>
        </div>
      </el-table-column>
    </el-table>

    <!-- el-dialog class="isAisPortAdd" :visible.sync="isAisPortAdd" v-if="isAisPortAdd" width="980px" append-to-body -->

    <el-dialog
      append-to-body
      width="980px"
      :visible.sync="dialogWin"
      :show-close="false"
      @closed="onAisPortModifyClose"
    >
      <ais-port-add
        :dialog-status="dialogObject.id ? '编辑' : '新增'"
        :tables-row="dialogObject"
        @handleClose="dialogWin = false"
        @successful="onAisPortModifySuccessAfter"
      />
    </el-dialog>
  </base-query>
</template>

<script>
import BaseQuery from '@/components/BaseQuery.vue'
import api from './api'
import AisPortAdd from '../basicPort/aisPortAdd.vue'

const reasonObject = {
  0: {
    title: '时区不一致',
    classname: 'mismatch-tz',
  },
  1: {
    title: '国家简码不一致',
    classname: 'mismatch-country',
  },
  2: {
    title: '未匹配',
    classname: 'mismatch',
  },
  3: {
    title: '未在ais港口中匹配',
    classname: 'mismatch-onais',
  },
}

let offset = 0,
  invalidids = [0, '']

export default {
  components: {
    BaseQuery,
    AisPortAdd,
  },

  mixins: [api],

  data() {
    return {
      mismatchResults: [],
      isloading: false,

      selections: [],

      removing: false,

      dialogWin: false,
      dialogObject: {},
    }
  },

  mounted() {
  //  this.refresh()
  },

  destroyed() {},

  methods: {
    handleSelection(selections) {
      this.selections = selections.map(it => it.id)
    },

    async removeAll() {
      this.removing = true

      try {
        if (await this.removePorts(this.selections)) {
          await this.refresh()
        }
      } finally {
        this.removing = false
      }
    },

    async removePorts(ids) {
      const resp = await this.$api.post(
        '/trace/aiseventops/deleteAisPortMismatchRecord',
        ids,
        { baseURL: '/' }
      )

      return resp.data.status === 1
    },

    async refresh() {
      this.isloading = true

      try {
        const resp = await this.$api.get(
          '/trace/aiseventops/listAisPortMismatchRecord',
          { baseURL: '/' }
        )

        if (resp.data.status === 1) {
          const records = resp.data.content.records || []

          const matchResults = resp.data.content.matchResults || {}

          records.forEach(record => {
            record['port'] = matchResults[record.id] || {}
            record['reason'] = this.mismatrchReason(record)
            record['portId'] = (record['port'] || '').id
          })

          this.mismatchResults = records
        }
      } finally {
        this.isloading = false
      }
    },

    mismatrchReason(record) {
      const reasons = []

      if (record.port.id) {
        if (record.tz !== undefined && record.port.porttimezone !== record.tz) {
          reasons.push(0)
        }

        if (
          record.countryCode &&
          record.port.countrycode !== record.countryCode
        ) {
          reasons.push(1)
        }

        if (!reasons.length) {
          if (!record.port.portcode) {
            reasons.push(2)
          }
        }
      } else {
        reasons.push(3)
      }

      return reasons
    },

    handleMismatchReasonClass(reasons) {
      return reasons.map(k => (reasonObject[k] || '').classname).filter(Boolean)
    },

    handleMismatchReasonMsg(reasons) {
      return reasons
        .map(k => (reasonObject[k] || '').title)
        .filter(Boolean)
        .join(', ')
    },

    doLookup(row) {
      this.dialogWin = true
      this.dialogObject = {
        id: row.portId || invalidids[offset++ % invalidids.length],
        portEnName: row.name,
        portCode: row.code || '',
        countryCode: row.countryCode || '',
        portTimezone:
          typeof row.tz === 'number' || typeof row.tz === 'string'
            ? row.tz.toString()
            : '',
        // hide
        hideId: row.id,
      }
    },

    onAisPortModifyClose() {
      this.dialogWin = false
      this.dialogObject = {}
    },

    async onAisPortModifySuccessAfter() {
      try {
        await this.$confirm('Ais港口保存成功, 是否删除当前行?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })

        if (await this.removePorts([this.dialogObject.hideId])) {
          await this.refresh()
        }
      } catch (e) {}

      this.onAisPortModifyClose()
    },
  },
}
</script>

<style lang="scss" scoped>
.mismatch-aisport {
  padding: 0;

  ::v-deep.dialog-is-open {
    background-color: rgb(250, 250, 226);
  }

  .mismatch-tz,
  .mismatch-country {
    color: brown;
    font-weight: bold;
  }

  .mismatch {
    color: brown;
  }

  .mismatch-onais {
    color: darksalmon;
  }
}
</style>
